export class ContainmentType {
}
ContainmentType.Disjoint = 0;
ContainmentType.Contains = 1;
ContainmentType.Intersects = 2;
